import React from 'react'
import Banner from '../Components/Banner/Banner';
import CoinsTable from '../Components/CoinsTable';

export default function Homepage() {
  return (
    <>
    <Banner />
    <CoinsTable />
    </>
  )
}
